import { render, staticRenderFns } from "./basic-panel.vue?vue&type=template&id=617007f2&lang=pug&"
import script from "./basic-panel.vue?vue&type=script&lang=js&"
export * from "./basic-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports